import * as React from 'react';

import t from './locales';
import { calculateJRWItemPrice } from './helpers';
import { ICurrency, IJRWTicketOrderItem } from './types';
import InventoryCartItemView from './InventoryCartItemView';
import Price from '../Shared/Price';

interface IProps {
  items: Array<IJRWTicketOrderItem>;
  currentExchangeRate?: number;
  localCurrency?: ICurrency;
}

const JRWInventoryTicketOrderItemList: React.FC<IProps> = (props) => {
  return (
    <React.Fragment>
      {props.items && props.items.map((item, index) => {
        const { name, plan, numPassengers } = item;
        const itemPrice = calculateJRWItemPrice(plan.adultSellingPrice, numPassengers);
        return (
          <InventoryCartItemView key={`jrw-inventory-ticket-order-item-${index}`}>
            <div>
              <p>{name} {plan.name}</p>
              <span className="mute">
                {numPassengers > 0 && <span>{t.adultNum()} {numPassengers}</span>}
              </span>
            </div>
            <Price
              price={itemPrice}
              fullPrice={itemPrice}
              fontSize={12}
              localCurrency={props.localCurrency}/>
          </InventoryCartItemView>
        )
      })}
    </React.Fragment>
  );
}

export default JRWInventoryTicketOrderItemList;
